module.exports = __webpack_public_path__ + "img/logo-lions.9ac67d84.png";